<script>
	import { onMount } from 'svelte';

	let dismissed = false;

	const dismissCookieNotice = () => {
		localStorage.setItem('cookieNoticeDismissed', 'true');
		dismissed = true;
	};

	onMount(() => {
		const storedValue = localStorage.getItem('cookieNoticeDismissed');
		dismissed = storedValue === 'true';
	});
</script>

{#if !dismissed}
	<div class="flex items-end justify-center fixed bottom-16 left-0 right-0 p-4 z-10">
		<div
			class="flex items-center space-x-6 2xl:space-x-11 3xl:space-x-11 5xl:space-x-11 6xl:space-x-11 bg-white py-6 px-9 rounded-[20px] shadow-md w-[900px]"
		>
			<p
				class="font-medium text-xs leading-4 2xl:text-[14px] 3xl:text-[14px] 5xl:text-[14px] 6xl:text-[14px]"
			>
				Используя наш сайт, вы соглашаетесь с тем, что мы используем cookies и другие похожие
				технологии. Вы можете изменить настройки браузера, если не согласны с этим.
			</p>
			<button
				on:click={dismissCookieNotice}
				class="bg-blue-400 text-white py-3.5 px-11 rounded-[10px] font-medium text-xs 2xl:text-[14px] 3xl:text-[14px] 5xl:text-[14px] 6xl:text-[14px]"
			>
				Хорошо
			</button>
		</div>
	</div>
{/if}
